import { Col, Divider, Form, FormInstance, FormProps, Row, Switch } from "antd";
import { ViagemFechada } from "../../../../Models/Domain/Viagem/ViagemFecahmento";
import { forwardRef, useEffect, useRef } from "react";
import ViagemFechamentoInfo from "./ViagemFechamentoInfo";
import { IViagemFechadaInserirParam, useViagemFechamentoObter } from "../../../../Services/Domain/Viagem/ViagemFechadaService";
import NotaFormBasic, { NotaFormInstanceRef } from "../../Financeiro/Titulo/Nota/NotaFormBasic";
import Nota from "../../../../Models/Financeiro/Titulo/Nota";
import { EnumNotaSituacao } from "../../../../Models/Financeiro/Titulo/Nota/NotaSituacao";
import { useContaViagemListarTodos } from "@/Services/Domain/Viagem/Financeiro/ContaViagemService";
import ContaViagemTable from "@/Components/Populados/Viagem/Financeiro/ContaViagem/ContaViagemTable";

export interface IViagemFechadaInstanceRef extends FormInstance<ViagemFechada> {
};

interface IViagemFechadaFormBasicProps extends Omit<FormProps, "initialValues"> {
    initialValues:IViagemFechadaInserirParam;
}

const ViagemFechadaFormBasic = forwardRef<IViagemFechadaInstanceRef, IViagemFechadaFormBasicProps>(function ViagemFechadaFormBasic(
    {
        initialValues,
        form : formParam,
        onFinish,
        ...rest
    }, 
    ref
) {
    const refNota = useRef<NotaFormInstanceRef|null>(null);
    const [ newForm ] = Form.useForm<ViagemFechada>();
    const form = formParam ?? newForm;

    const atualizarNotaFormValue = Form.useWatch("atualizarNota", form);

    const {
        data : dataFechamentoRelatorio,
        isPending : isPendingFechamentoRelatorio,
        isLoading : isLoadingFechamentoRelatorio,
        isSuccess : isSuccessFechamentoRelatorio
    } = useViagemFechamentoObter({
        codViagem : initialValues.viagemFechada.viagem!.codigo!
    });

    const {
        data : dataAdvs,
        isPending : isPendingAdvs,
        isLoading : isLoadingAdvs
        //isSuccess : isSuccessAdvs
    } = useContaViagemListarTodos({
        ativo : true,
        codCentrosCustos : [dataFechamentoRelatorio?.viagem?.centroDeCusto?.codigo ?? -1],
        enabled : !!dataFechamentoRelatorio?.viagem?.centroDeCusto?.codigo
    });

    const carregandoAdvs = isPendingAdvs || isLoadingAdvs;

    useEffect(() => {
        if (dataFechamentoRelatorio != null)
            form.setFieldsValue({
                ...initialValues,
                ...dataFechamentoRelatorio
            } as any);
    }, [isSuccessFechamentoRelatorio]);

    return <Form
        {...rest}
        ref={ref}
        form={form}
        component={"div"}
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues}
        disabled={isLoadingFechamentoRelatorio || isPendingFechamentoRelatorio}
        onFinish={(data) => {
            refNota.current?.validateFields({ validateOnly : false })?.then((repsonseFormNota) => {
                data.viagemFechada.nota = repsonseFormNota;
                onFinish?.(data);
            })
            .catch(ex => {

            });
        }}
    >
        <Row gutter={8} wrap>
            <Form.Item hidden name={["viagemFechada", "viagem"]}></Form.Item>
            <Form.Item hidden name={["viagemFechada", "codViagem"]}></Form.Item>
            <Col xs={24}>
                <ViagemFechamentoInfo viagem={initialValues.viagemFechada?.viagem!} title={null} />
            </Col>
            {(carregandoAdvs || (dataAdvs?.length ?? 0) > 0) && <Col xs={24}>
                <Divider orientation="left">ADVs</Divider>
                <ContaViagemTable
                    opcaoEncerraFixa={true}
                    loanding={carregandoAdvs}
                    dataSource={{
                        registros : dataAdvs ?? [],
                        tamanho : dataAdvs?.length ?? 0,
                        totalPaginas : 1,
                        pagina : 1
                    }}
                />
            </Col>}
            <Col xs={24}>
                <Divider orientation="left">{dataFechamentoRelatorio?.codigo ? "Nota a cancelar" : "Nota a emitir"}</Divider>
                
                <Form.Item
                    label={dataFechamentoRelatorio?.codigo ? "Cancelar nota junto a prefeitura?" : "Emitir nota junto a prefeitura?"}
                    name={["atualizarNota"]}
                    rules={[{ required: true }]}
                >
                    <Switch checkedChildren="Sim" unCheckedChildren="Não" />
                </Form.Item>
                
                <NotaFormBasic
                    ref={refNota}
                    disabled={{
                        codPrestador : atualizarNotaFormValue,
                        codTomador : true,
                        numeroRps : atualizarNotaFormValue,
                        serieRps : atualizarNotaFormValue,
                        numero : atualizarNotaFormValue,
                        codSituacao : atualizarNotaFormValue,
                        url : atualizarNotaFormValue
                    }}
                    nota={dataFechamentoRelatorio?.nota ?? {
                        valor : (dataFechamentoRelatorio?.lucroBruto ?? 0) < 0 ? 0 : (dataFechamentoRelatorio?.lucroBruto ?? 0),
                        dataCompetencia : dataFechamentoRelatorio?.viagem?.inicio,
                        codPrestador : dataFechamentoRelatorio?.viagem?.centroDeCusto?.codEmpresa,
                        prestador : dataFechamentoRelatorio?.viagem?.centroDeCusto?.empresa,
                        codTomador : dataFechamentoRelatorio?.viagem?.pago ? dataFechamentoRelatorio?.viagem?.escola?.pessoa?.codigo : undefined,
                        tomador : dataFechamentoRelatorio?.viagem?.pago ? dataFechamentoRelatorio?.viagem?.escola?.pessoa : undefined,
                        codSituacao : EnumNotaSituacao.Pendente
                    } as Nota}
                />
            </Col>
        </Row>
    </Form>
});
export default ViagemFechadaFormBasic;